var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-wrap"},[(_vm.ebayBulk)?_c('EbayBulkCategorySelector',{on:{"closed":function($event){_vm.ebayBulk = false}}}):_vm._e(),_c('button',{staticClass:"btn-dark-button mt-20 mx-auto",on:{"click":function($event){_vm.ebayBulk = true}}},[_vm._v(" Ebay Assign categories in bulk ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }